import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useIntl, FormattedMessage } from "react-intl";
import { Form } from "react-bootstrap";

import { Loading } from "../../../common/loading/loading";

export const TemplateSelect = ({
  availableTemplates,
  selectedTemplate,
  isValid,
  isInvalid,
  disabled,
  showName,
  handleTemplateSelect,
}) => {
  const intl = useIntl();
  const [allTemplates, setAllTemplates] = useState(null);

  useEffect(() => {
    const loadAllTemplates = () => {
      let availableTemplatesCopy = JSON.parse(
        JSON.stringify(availableTemplates),
      );
      if (
        selectedTemplate?.template.version_id &&
        !availableTemplatesCopy.find(
          (t) => t.template.version_id === selectedTemplate.template.version_id,
        )
      ) {
        availableTemplatesCopy = [
          {
            id: selectedTemplate.template.version_id,
            name: intl.formatMessage(
              { id: "data.serviceworksheet.form.templatenameandversion" },
              {
                name: selectedTemplate.template.name,
                version: selectedTemplate.template.version,
              },
            ),
            template: selectedTemplate.template,
          },
          ...availableTemplatesCopy,
        ];
      }
      availableTemplatesCopy.sort((t1, t2) => t1.name.localeCompare(t2.name));

      setAllTemplates(availableTemplatesCopy);
    };

    const checkNotEmpy = (items) => {
      return items.filter((item) => item === null).length === 0;
    };

    if (checkNotEmpy([intl, availableTemplates])) {
      loadAllTemplates();
    }
  }, [intl, selectedTemplate, availableTemplates]);

  if (!allTemplates) {
    return <Loading />;
  }

  return (
    <div className="d-flex">
      {showName ? (
        <Form.Control
          className="me-2"
          isValid={isValid}
          isInvalid={isInvalid}
          disabled={disabled}
          value={selectedTemplate?.name}
          onChange={(event) => {
            handleTemplateSelect(
              selectedTemplate?.template,
              event.target.value,
            );
          }}
        />
      ) : null}
      <Form.Select
        value={
          selectedTemplate?.template?.version_id
            ? selectedTemplate?.template?.version_id
            : 0
        }
        isValid={isValid}
        isInvalid={isInvalid}
        disabled={disabled}
        onChange={(event) => {
          const newSelectedTemplate =
            event.target.value === 0
              ? null
              : allTemplates.find((t) => t.id === +event.target.value).template;

          handleTemplateSelect(
            newSelectedTemplate,
            selectedTemplate?.name
              ? selectedTemplate?.name
              : intl.formatMessage({
                  id: "data.serviceworksheet.form.templatename",
                }),
          );
        }}
      >
        {selectedTemplate?.template.version_id ? null : (
          <option value="0">
            <FormattedMessage id="data.serviceworksheet.form.templates.value.null" />
          </option>
        )}
        {allTemplates.map((template) => (
          <option key={template.id} value={template.id}>
            {template.name}
          </option>
        ))}
      </Form.Select>
    </div>
  );
};

TemplateSelect.propTypes = {
  availableTemplates: PropTypes.array.isRequired,
  selectedTemplate: PropTypes.object,
  isValid: PropTypes.bool.isRequired,
  isInvalid: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  showName: PropTypes.bool.isRequired,
  handleTemplateSelect: PropTypes.func.isRequired,
};
